"use client"

import { useAppDispatch } from "@/hooks/redux"
import { storeActions } from "@/lib/redux/features/store/reduce"
import { useCallback, useEffect } from "react"

const refSSR: { current?: any } = { current: null }
let lastScrollTop: number = 0

const AppContainer = ({ children, store, isDesktop }: any) => {
  const dispatch = useAppDispatch()

  if (!refSSR.current) {
    refSSR.current = true
    dispatch(storeActions.setIsDesktop(!!isDesktop))
    dispatch(storeActions.setStoreData(store))
  }

  const onScroll = useCallback((e: Event) => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop) {
      // Scrolling down
      document.body.classList.add("scroll-down");
      document.body.classList.remove("scroll-up");
    } else {
      // Scrolling up
      document.body.classList.add("scroll-up");
      document.body.classList.remove("scroll-down");
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // avoid negative values
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    if (localStorage.getItem('v') !== '1') {
      localStorage.clear()
      localStorage.setItem('v', '1')
    }
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <>
      {children}
    </>
  )
}

export default AppContainer